import {Component} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";

@Component({
    selector: 'phx-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent extends BaseComponent {

    constructor(
        private userService: UserService,
        private loggerService: LoggerService
    ) {
        super(userService, loggerService);
    }
}
